<template>
    <div class="legal-page">
        <div class="legal-body">
            <div class="text-side">
                <div class="page-name">Legal</div>
                <div class="legal-links">
                    <div v-for="(legal, index) in legals" :key="index" class="link">
                        <div class="link-line">
                            <span
                                ><a :href="legal.href" class="link">
                                    <span class="legal-name">{{ legal.name }}</span>
                                </a></span
                            >
                            <a :href="legal.href" class="arrow-link">
                                <img src="/images/arrow-right.png" alt="legal" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="img-side">
                <img src="/images/legal-page.png" alt="link" class="img-fluid" />
            </div>
        </div>
        <div class="call-to-action">
            <div class="call-to-action-wrapper">
                <div><span class="question">Still have questions?</span></div>
                <div>
                    <span class="answear"
                        >Can’t find the answer you’re looking for? Please contact us.</span
                    >
                </div>
            </div>
            <button class="action-btn" @click="contactPage">
                <span class="btn-text">Get in touch</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LegalPage',
        data() {
            return {
                legals: [
                    {
                        name: 'Terms of service',
                        href: '/terms-of-service'
                    },
                    {
                        name: 'Privacy policy',
                        href: '/privacy-policy'
                    },
                    {
                        name: 'Payment terms',
                        href: '/payment-terms'
                    },
                    {
                        name: 'Refund and cancellations policy',
                        href: '/refunds-and-cancellation-policy'
                    },
                    {
                        name: 'Dispute resolution policy',
                        href: '/dispute-resolution-policy'
                    },
                    { name: 'Off-Platform Policy', href: '/off-platform-policy' }
                ]
            }
        },
        methods: {
            contactPage() {
                window.location.href = '/contact-us'
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .legal-page {
        display: flex;
        flex-direction: column;
        background: #000;
    }
    .legal-body {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    .text-side {
        flex-direction: column;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 24px;
        margin-left: 90px;
    }
    .page-name {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .legal-links {
        display: flex;
        flex: 1;
        flex-direction: column;
        padding: 24px 0px;
        align-items: flex-start;
        gap: 24px;
        width: 100%;
    }
    .link {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-decoration: none;
        padding-right: 30px;
    }
    .link-line {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: space-between;
    }
    .arrow-link {
        display: flex;
        align-items: flex-end;
    }
    .legal-name {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .call-to-action {
        display: flex;
        flex: 1;
        margin-right: 100px;
        justify-content: space-between;
        align-items: center;
        padding: 100px 50px 100px;
    }
    .call-to-action-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
    .question {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .answear {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 20px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
    }
    .action-btn {
        display: flex;
        padding: 11px 30px 12px 30px;
        border: none;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        background: #cdeb09;
    }
    .btn-text {
        color: #000;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    @media only screen and (max-width: 768px) {
        .legal-body {
            flex-direction: column;
            align-items: flex-start;
        }
        .text-side {
            margin-left: 0;
            padding: 16px;
            width: 100%;
        }
        .link-line {
            display: flex;
            padding: 24px 0px;
            align-items: center;
            gap: 24px;
            align-self: stretch;
        }
        .call-to-action {
            flex-direction: column;
            align-items: flex-start;
            margin-right: 0;
        }
        .call-to-action-wrapper {
            padding: 32px 20px;
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
            align-self: stretch;
        }
        .action-btn {
            margin-left: 20px;
        }
    }
</style>
